export const mockCheckoutMeta = {
  'storeOrder': {
    'orderItems': [
      {
        'id': '2c9f848064b2307c0164ca54c10513d9',
        'price': 13.9,
        'name': 'Sample Product 1',
        'status': 0,
        'muteUntil': null,
        'collectionStartDate': null,
        'collectionEndDate': null,
        'collectionStartTime': null,
        'collectionEndTime': null,
        'availableDays': null,
        'isValid': true,
        'isPromotionalItem': false,
        'promotionReference': null,
        'promotionName': null,
        'quantity': 2,
        'itemReference': '2c9f8fb15494473b015494af94f3027b',
        'subitemChoices': null
      },
      {
        'id': '2c9f848064b2307c0164ca54c10513d9',
        'price': 10.5,
        'name': 'Sample Product 2',
        'status': 0,
        'muteUntil': null,
        'collectionStartDate': null,
        'collectionEndDate': null,
        'collectionStartTime': null,
        'collectionEndTime': null,
        'availableDays': null,
        'isValid': true,
        'isPromotionalItem': false,
        'promotionReference': null,
        'promotionName': null,
        'quantity': 1,
        'itemReference': '2c9f8fb15494473b015494af94f3027b',
        'subitemChoices': null
      }
    ]
  },
  'customer': {}
}

export const mockCheckoutResult = {
  id: '8a8194717b5f4500017b61632572079f',
  storeId: '8a8197d678da02e40178e3da3a6605af',
  storeName: 'Example',
  defaultStoreId: null,
  menuId: '8a8197d678da02e40178e3da39f70584',
  menuName: 'Example',
  isPickup: true,
  deliveryAddressAutoComplete: null,
  deliveryAddress: null,
  deliveryAddressOne: null,
  deliveryAddressTwo: null,
  deliveryAddressCity: null,
  deliveryAddressState: null,
  deliveryAddressPostal: null,
  deliveryAddressCountry: null,
  deliveryInstructions: null,
  deliveryAddressType: 'building',
  deliveryAddressTwoDetails: {
    buildingName: '',
    unitNumber: null
  },
  customerLatitude: null,
  customerLongitude: null,
  subtotal: 10,
  total: 10,
  deliveryCost: 0,
  deliveryFreeAfter: 0,
  locationDeliveryCost: 0,
  surchargeDeliveryCost: 0,
  remainingAmountToFreeDelivery: 0,
  minimumOrder: 0,
  maximumOrder: null,
  roundingAdjustment: 0,
  storeAddress: 'Oddle Eats',
  orderNumber: '000001',
  orderDate: '20 Aug 2021',
  orderDateRank: 1629426577000,
  orderTime: '10:29 AM',
  collectionDate: '20 Aug 2021',
  collectionTime: '11:15 AM to 11:30 AM',
  earliestCollectionTime: '20 08 2021',
  currencyCode: 'SGD',
  totalAmountInSubUnit: 100,
  status: 2,
  orderPromotions: null,
  taxAndCharges: null,
  orderItems: [
    {
      id: '8a8194717b5f4500017b6163492a07a0',
      price: 10,
      name: 'Sample Item',
      status: 0,
      muteUntil: null,
      collectionStartDate: null,
      collectionEndDate: null,
      collectionStartTime: null,
      collectionEndTime: null,
      availableDays: null,
      isValid: true,
      isPromotionalItem: false,
      promotionReference: null,
      promotionName: null,
      quantity: 1,
      itemReference: '8a8197d678da02e40178e3da3b6405bb',
      itemId: '8a8197d678da02e40178e3da3b5c05ba',
      subitemChoices: null
    }
  ],
  deliveryRequestDto: null,
  token: 'MniclZOGqb6dqe2RdCjoNKm68R4DDawaRujHPI0lsOc',
  storeOrderPaymentDetails: {
    id: '8a8194717b5f4500017b61646c5007aa',
    accessKey: null,
    version: null,
    createdOn: '2021-08-20 10:29:36',
    paymentStatus: 'PAID',
    paymentProcessReference: 'pm_1JQNU9Lvc0onZ7sfmRtPyalr',
    paymentReference: 'pi_3JQNUBLvc0onZ7sf0yBRXnmY',
    storeOrderTotalAmount: 10,
    paymentAmount: 10,
    refundAmount: 0,
    network: 'VISA',
    issuer: 'THE CHASE MANHATTAN BANK',
    paymentMethod: 'Credit Card',
    transactionReference: null
  },
  orderVouchers: null,
  pickup: true
}
